import dataLayer from '../dataLayer/reducer';
import grey from '@material-ui/core/colors/grey';
import { TOGGLE_ALL as TOGGLE_ALL_EMP_, TOGGLE_EMPLOYED_BY_NAME as TOGGLE_EMPLOYED_BY_NAME_ } from '../employedCount/actions';
import { TOGGLE_ALL_TYPE as TOGGLE_ALL_EMP_VEIDS, TOGGLE_EMPLOYED_BY_NAME as TOGGLE_EMPLOYED_BY_NAME_VEIDS } from '../employedCountVeids/actions';
import { TOGGLE_ALL as TOGGLE_ALL_IND, TOGGLE_IDUSTRY } from '../mapData/actions';

const ALL_STUDENTS_TT = 'Anonimizētu skolēnu dzīvesvietu aptuvens izvietojums';
const STUDENTS_SCHOOLS_TT = 'Anonimizētu skolēnu deklarēto dzīves vietu aptuvens izvietojums pēc apmeklētās izglītības iestādes 1.septembrī; apļa laukums proporcionāls skolēnu skaitam (lai redzētu skolēnu izvietojumu, jāaktivizē interesējošās skolas aplītis)';
const MUNICIP_SCHOOLS_TT = 'Konkrētajā pašvaldībā deklarēto skolēnu apmeklētās skolas pēc skolēnu skaita no attiecīgās pašvaldības';

export const ALL_STUDENTS = 'Visi skolēni';
export const STUDENTS_BY_SCHOOLS = 'Skolēni pēc skolas';
export const STUDENT_SCHOOLS_BY_MUNICIP = 'Pašvaldību deklarēto skolēnu skolas / izvēlēties pašvaldību';

const DefaultState = {
    active: [],
    activeData: [],
    id: 1,
    data: [{
        id: 'students',
        name: 'Skolēni',
        style: {fontSize: '1em', color: grey[300], borderBottom:'1px solid ' + grey[300] },
        textStyle: {color: grey[800]},
        childs: [
            {id: 'all_students', name: ALL_STUDENTS, active: false, tooltip: true, tooltipText: ALL_STUDENTS_TT},
            {id: 'students_by_schools', name: STUDENTS_BY_SCHOOLS, active: false, tooltip: true, tooltipText: STUDENTS_SCHOOLS_TT},
            {id: 'students_schools_by_municip',name: STUDENT_SCHOOLS_BY_MUNICIP, active: false, tooltip: true, tooltipText: MUNICIP_SCHOOLS_TT}
        ]
    }]
}

class StuMDataLayer extends dataLayer {

    reducerExtender(state, action) {    
        
        switch(action.type) {
            
            case TOGGLE_ALL_EMP_VEIDS:
            case TOGGLE_EMPLOYED_BY_NAME_VEIDS:
            case TOGGLE_ALL_EMP_:
            case TOGGLE_EMPLOYED_BY_NAME_:
            case TOGGLE_ALL_IND:
            case TOGGLE_IDUSTRY:
            case 'population_TOGGLE_BY_IDS_SINGLE':
                var newstate = Object.assign({}, state);
                this.recursiveLoop(newstate.data, (entry)=>{
                   
                        entry.active = false;
                    
                });
                
                return newstate;
            break;
        }

    }
}


var StudentsMenuData = new StuMDataLayer({
  key: "students",
  defaultState: DefaultState
});

const StudentsMenuExport = StudentsMenuData.export();

export const studentsMenu = StudentsMenuExport.students;
export default StudentsMenuExport;


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/studentsMenu/reducer.js